import { Trans } from '@lingui/macro';
import React from 'react';
import Link from '../../shared/Link/Link';
import './ImportantBlock.pcss';
import { banners } from '../../../constants/iterableTexts';

interface BannerProps {
  url: string;
  type: string;
  title: string;
  link: string;
}

export default (): JSX.Element => (
  <div className="Important__content">
    <div className="Important__title">
      <Trans>Важно знать</Trans>
    </div>
    <div className="Important__items">
      {banners.map(({ type, url, link, title }: BannerProps, index) => (
        <Link
          className="Important__item"
          href={url}
          key={index + type}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="Important__itemType">{type}</div>
          <div className="Important__itemTitle">{title}</div>
          <div className="Important__itemLink">{link}</div>
        </Link>
      ))}
    </div>
  </div>
);
